<template>
  <div>
    <h1 class="main-header" v-translate translate-context="form'">Create Event Owner</h1>
    <Form :data=empty @save="onSave" :save_text="$pgettext('form','Create')"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Form from "@/domain/event_owner/components/Form.vue";
import {SuccessNotification} from "@/domain/core/exception/exceptions";

export default {
  name: 'NewEventOwner',
  components: {Form},
  data() {
    return {
      empty: {
        company_name: '',
        third_level_domain: '',
        logo: null,
        login_subtitle: {},
        hide_cart: false,
        show_calendar: false,
        hide_app_store_links: false,
        hide_powered_by_logo: false,
        disable_social_login: false,
        hide_events_on_pica: false,
        hide_pica_events: false,
        marketing_consent_description: {},
        hide_marketing_consent_last_update_date: false,
        upload_bucket_name: '',
        face_checkin_privacy_statement: {},
        share_checkin_privacy_statement: {},
        footer_company_info: '',
      }
    }
  },
  computed: {
    ...mapGetters('eventOwner', [
      'event_owner',
    ]),
  },
  methods: {
    ...mapActions('eventOwner', [
      'createEventOwner',
    ]),
    async onSave(data) {
      await this.createEventOwner(data)
      await this.$router.push({name: 'event_owner.detail', params: {id: this.event_owner.id}})
      throw new SuccessNotification(this.$pgettext('event_owner', 'Event Owner created!'))
    }
  }
}
</script>

<style scoped>

</style>
